import { CallActivityMessage } from './call-activity-message';
import { EmailActivityMessage } from './email-activity-message';
import { FormSubmissionMessage } from './form-submission-message';
import { MailboxEmailActivityMessage } from './mailbox-email-activity-message';
import { SmsActivityMessage } from './sms-activity-message';
import {
  OwnershipEventMessage,
  TaskEventMessage,
} from './system-activity-message';
import type { ContactActivity } from './types';
import type { Id } from '@minty/shared/ids';

export function ActivityMessage({
  activity,
  contactId,
  contactName,
}: {
  activity: ContactActivity;
  contactId: Id<'contacts'>;
  contactName: string;
}) {
  if (activity.type === 'taskEvent') {
    return <TaskEventMessage activity={activity} />;
  }

  if (activity.type === 'ownershipEvent') {
    return <OwnershipEventMessage activity={activity} />;
  }

  if (activity.type === 'call') {
    return <CallActivityMessage activity={activity} />;
  }

  if (activity.type === 'sms') {
    return <SmsActivityMessage activity={activity} />;
  }

  if (activity.type === 'mailboxEmail') {
    return <MailboxEmailActivityMessage activity={activity} />;
  }

  if (activity.type === 'formSubmission') {
    return (
      <FormSubmissionMessage
        activity={activity}
        contactId={contactId}
        contactName={contactName}
      />
    );
  }

  return <EmailActivityMessage activity={activity} />;
}
